import { IconVolume, IconInfoCircle, IconAlertTriangle, IconBellExclamation, IconMessage } from '@tabler/icons-react';
export const ITEMS_PER_PAGE = 10; // this value must keep same as the one defined in backend!
// 定义公告类型的数组
export const ANNOUNCEMENT_TYPES = [
  {
    value: 'informative',
    label: '信息简报',
    icon: <IconVolume stroke={1.5} size="1rem" />,
    color: '#4096ff', // 使用主题的主要颜色
    type: 'info'
  },
  {
    value: 'urgent',
    label: '紧急通告',
    icon: <IconAlertTriangle stroke={1.5} size="1rem" />,
    color: '#4096ff', // 使用主题的错误颜色
    type: 'error'
  },
  {
    value: 'maintenance',
    label: '维护通知',
    icon: <IconBellExclamation stroke={1.5} size="1rem" />,
    color: '#4096ff', // 使用主题的次要颜色
    type: 'warning'
  },
  {
    value: 'policy_update',
    label: '政策通告',
    icon: <IconMessage stroke={1.5} size="1rem" />,
    color: '#4096ff', // 使用主题的信息颜色
    type: 'success'
  },
  {
    value: 'promotion',
    label: '优惠通告',
    icon: <IconInfoCircle stroke={1.5} size="1rem" />,
    color: '#4096ff', // 使用主题的成功颜色
    type: 'success'
  }
];
